var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "upload",
      staticClass: "avatar-uploader",
      attrs: {
        "before-upload": _vm.beforeUpload,
        action: "default",
        disabled:
          _vm.status === "pending" ||
          _vm.status === "approved" ||
          (_vm.status === "refuse" &&
            _vm.fileList.length !== 0 &&
            !_vm.deleteable),
        "http-request": _vm.upload,
        headers: _vm.uploadHeaders,
        "show-file-list": false,
        "list-type": _vm.type === "img" ? "picture" : "text",
        "file-list": _vm.fileList,
        "before-remove": _vm.remove,
        "on-success": _vm.handleAvatarSuccess,
        "on-error": _vm.uploadError
      }
    },
    [
      _c("div", { staticClass: "upload-bt" }, [_vm._v("上传")]),
      _vm._v(" "),
      _vm.complete > 0 && _vm.complete < 100
        ? _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("el-progress", {
                staticStyle: { flex: "1" },
                attrs: {
                  percentage: _vm.complete,
                  color: "#f56c6c",
                  "text-inside": true
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticStyle: {
                  width: "8px",
                  height: "8px",
                  "margin-left": "3px"
                },
                attrs: { src: require("@/assets/images/icon_close.png") },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.removeFile.apply(null, arguments)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fac87aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fac87aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaterialUploadBt.vue
// module id = null
// module chunks = 